import { title } from '@/lang' // Internationalization

interface ISettings {
  title: string // Overrides the default title
  errorLog: string[] // The env to enable the errorlog component, default 'production' only
  devServerPort: number // Port number for webpack-dev-server
}

// You can customize below settings :)
const settings: ISettings = {
  title: title,
  errorLog: ['production'],
  devServerPort: 9527,
}

export default settings
